import request from '@/utils/request'
import { submit } from './base'

export function getPublicKey() {
  return request({
    url: '/api/user/getPublicKey',
  })
}

export async function doLogin(data) {
  return request({
    url: '/api/user/login',
    data,
  })
}

export async function doLoginByTempToken(data) {
  return request({
    url: '/api/user/loginByTempToken',
    data,
  })
}

export function doRegister(data) {
  return request({
    url: '/api/user/register',
    data,
  })
}

export async function doRefreshToken(refreshToken, deviceId) {
  const data = { refreshToken: refreshToken, deviceID: deviceId }
  return request({
    url: '/api/user/refreshToken',
    data,
  })
}

export function getUserInfo() {
  return submit('/api/user/getUserInfo')
}

export function doLogout() {
  return request({
    url: '/api/user/logOut',
  })
}

export function getXiebutouToken() {
  return submit('/api/token/getXiebutouToken')
}
